import { useContext, useState } from "react";
import axios from "../axios";
import { UserContext } from "../../components/context/UseContext";
import { toast } from "sonner";
import { useProfile } from "./profile";

export const useReferrals = () => {
  const { token } = useContext(UserContext);
  const [referrals, setReferrals] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isClaimed, setIsClaimed] = useState(false);
  const [claminedPoints, setClaimedPoints] = useState(null);
  const { getProfileInfo } = useProfile();
  const ListReferrals = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get("/audiences/list-referrals", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (res.status === 200) {
        setReferrals(res.data);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
      toast.error(err.respose.data.message);
    }
  };

  const RedeemReferrals = async () => {
    try {
      setLoading(true);
      const res = await axios.put(
        "/audiences/redeem-referrals",

        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
      if (res.status === 200) {
        setIsClaimed(true);
        setLoading(false);
        getProfileInfo(token, true);
        //res.data.data.total_referral_point
        setClaimedPoints(30);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.respose.data.message);
    }
  };

  return {
    ListReferrals,
    referrals,
    isLoading,
    RedeemReferrals,
    loading,
    setIsClaimed,
    isClaimed,
    claminedPoints,
  };
};
